import { render, staticRenderFns } from "./InstitutionManage.vue?vue&type=template&id=3316572c&scoped=true&"
import script from "./InstitutionManage.vue?vue&type=script&lang=js&"
export * from "./InstitutionManage.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionManage.vue?vue&type=style&index=0&id=3316572c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3316572c",
  null
  
)

export default component.exports